/** @jsxImportSource @emotion/react */

import { Modal } from "components/common/Modal";
import BottomNavigate from "components/mobile/BottomNavigate";
import MHeader from "components/mobile/MHeader";
import Sidebar from "components/mobile/Sidebar";
import { Outlet } from "react-router-dom";

import { DefaultLayoutStyle } from "./index.style";

export const DefaultLayout = () => {
  return (
    <div css={DefaultLayoutStyle.index}>
      <MHeader />
      <main css={DefaultLayoutStyle.main}>
        <Outlet />
      </main>
      <BottomNavigate />
      <Modal />
      <Sidebar />
    </div>
  );
};
